import { ArrowLeft } from "lucide-react";
import { Link, Navigate, useParams } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import {
	StageForm,
	StageFormSkeleton,
} from "@/features/stages/components/stage-form";
import { useActiveObra } from "@/features/stages/hooks/use-active-obra.ts";
import { useStage } from "@/features/stages/hooks/use-stage.ts";
import { useStages } from "@/features/stages/hooks/use-stages.ts";
import { toStage } from "@/features/stages/utils/map.ts";

export function EtapaEditPage() {
	const { obra: obraKey, stageId } = useParams();
	const { obra, isLoading } = useActiveObra();
	const stagesQuery = useStages(obra?.id);
	const stageQuery = useStage(obra?.id, stageId);

	const listPath = `/${obraKey}/etapas`;

	if (isLoading || (obra && (stagesQuery.isPending || stageQuery.isPending))) {
		return (
			<div className="stage-edit-page">
				<div className="page-header-skeleton">
					<Skeleton className="page-header-skeleton__title" />
					<Skeleton className="page-header-skeleton__subtitle" />
				</div>
				<StageFormSkeleton withStatus />
			</div>
		);
	}

	if (!obra || stagesQuery.data?.lock.locked) {
		return <Navigate to={listPath} replace />;
	}

	if (stageQuery.isError || !stageQuery.data) {
		return (
			<Card className="card-narrow">
				<CardContent className="card-state">
					<p>Etapa não encontrada.</p>
					<Button asChild variant="outline">
						<Link to={listPath}>
							<ArrowLeft />
							Voltar para etapas
						</Link>
					</Button>
				</CardContent>
			</Card>
		);
	}

	const stage = toStage(stageQuery.data.stage);

	return (
		<div className="stage-edit-page">
			<div>
				<h1 className="page-title">Editar Etapa</h1>
				<p className="page-subtitle">
					Atualize os dados da etapa {stage.name}.
				</p>
			</div>

			<StageForm
				mode="edit"
				constructionId={obra.id}
				stages={stagesQuery.data?.stages ?? []}
				stage={stage}
				listPath={listPath}
			/>
		</div>
	);
}
